import { Card, CardContent, Paper } from '@material-ui/core';
import { PlayCircleFilled } from '@material-ui/icons';
import React from 'react'
import { Line } from 'react-chartjs-2';
import palette from '../../../../theme/palette';
import { defaultPaperPadding } from '../../../../config';

const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    legend: { display: false },
    cornerRadius: 20,
    tooltips: {
        enabled: true,
        mode: 'index',
        intersect: false,
        borderWidth: 1,
        borderColor: palette.divider,
        backgroundColor: palette.white,
        titleFontColor: palette.text.primary,
        bodyFontColor: palette.text.secondary,
        footerFontColor: palette.text.secondary
    },
    layout: { padding: 0 },
    scales: {
        xAxes: [
            {
                barThickness: 12,
                maxBarThickness: 10,
                barPercentage: 0.5,
                categoryPercentage: 0.5,
                ticks: {
                    fontColor: palette.text.secondary
                },
                gridLines: {
                    display: true,
                    drawBorder: true,
                    color: '#c3c3c3',
                    zeroLineColor: '#c3c3c3',
                    drawTicks: false
                }
            }
        ],
        yAxes: [
            {
                ticks: {
                    fontColor: palette.text.secondary,
                    beginAtZero: true,
                    min: 0
                },
                gridLines: {
                    display: false,
                    borderDash: [2],
                    borderDashOffset: [2],
                    color: palette.text.secondary,
                    drawBorder: false,
                    zeroLineBorderDash: [2],
                    zeroLineBorderDashOffset: [2],
                    zeroLineColor: palette.text.secondary
                }
            }
        ]
    }
};



export const LineChart = props => {
    // Data Object model = {label: String, value: int}
    const { dataObjects, label, description } = props

    const labels = [];

    let total = 0

    dataObjects.forEach((dataObj) => {
        if (dataObj.value != 0) {
            if (labels.find((l) => l == dataObj.label) == undefined) {
                labels.push(dataObj.label)
            }

            total += dataObj.value
        }
    })

    const data = {
        labels,
        datasets: [
            {
                label: label,
                pointRadius: 5,
                pointHoverRadius: 7,
                pointBackgroundColor: 'white',
                pointBorderWidth: 3,
                lineTension: 0,
                data: labels.map((l) => {
                    const datasOnLabel = dataObjects.filter((dataObj) => {
                        return dataObj.label == l
                    })

                    let count = 0
                    datasOnLabel.forEach((d) => {
                        count += d.value
                    })

                    return count
                }),
                borderColor: palette.primary.main,
                backgroundColor: 'transparent'
            },
        ],
    };
    return <Card style={{ height: '100%', borderRadius: '15px', display: 'flex', flexDirection: 'column', padding: defaultPaperPadding }}>
        <div className={'paperData'}>
            <div style={{ padding: '10px 20px', color: 'grey' }}>
                <h3>{label}</h3>
                <h1 style={{ padding: '10px 0', marginRight: '5px' }}>{total}</h1>
                <h3 style={{ color: 'lightgrey' }}>{description}</h3>
            </div>
        </div>
        <CardContent style={{ height: '100%' }}>
            <Line options={options} data={data} />
        </CardContent>
    </Card>
}
